import { render, staticRenderFns } from "./ClientDeleteDialog.vue?vue&type=template&id=0683ac45&scoped=true"
import script from "./ClientDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ClientDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683ac45",
  null
  
)

export default component.exports